import { Button, SaveButton, Toolbar } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { CancelAndReturnModal, useGetCurrentStep } from '@pumpkincare/shared';

import useBooleanInput from '../../../../../hooks/useBooleanInput';
import RoutePaths from '../../../../../routes';
import SendQuoteByEmailModal from '../../../../quotes/quoteFlow/view/SendQuoteByEmailModal';

// Step index of the plan selection tab (Details = 0, Plans = 1, Checkout = 2)
const PLAN_SELECTION_STEP = 1;

function WellnessQuoteToolbar({ edit = false, selectedPlans = {}, quote = {} }) {
  const navigate = useNavigate();
  const { state: routerState } = useLocation();
  const currentStep = useGetCurrentStep();
  const [isCancelModalOpen, toggleIsCancelModalOpen] = useBooleanInput(false);
  const [isSendEmailModalOpen, toggleIsSendEmailModalOpen] = useBooleanInput(false);

  function handleNextClick({ data }) {
    navigate(
      edit
        ? `/wellness-quotes/${data.id}/${currentStep + 1}`
        : `/wellness-quotes/create/${currentStep + 1}`,
      { state: routerState }
    );
  }

  return (
    <Toolbar
      sx={{
        padding: '32px 24px',
        display: 'flex',
        gap: '40px',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', gap: '40px' }}>
        {currentStep === PLAN_SELECTION_STEP ? (
          <Button
            label='SEND'
            type='button'
            variant='text'
            sx={{ color: '#5368F5' }}
            startIcon={<SendIcon />}
            onClick={() => toggleIsSendEmailModalOpen(true)}
          />
        ) : null}
      </div>

      {currentStep === PLAN_SELECTION_STEP ? (
        <Typography variant='body1' sx={{ fontWeight: 500 }}>
          TOTAL: $
          {Object.values(selectedPlans)
            .reduce((result, { price }) => result + parseFloat(price), 0)
            .toFixed(2)}{' '}
          / MO
        </Typography>
      ) : null}

      <div
        style={{
          display: 'flex',
          gap: '40px',
        }}
      >
        <Button
          label='CANCEL'
          variant='contained'
          color='error'
          sx={{ width: '180px' }}
          type='button'
          onClick={toggleIsCancelModalOpen}
        />

        <SaveButton
          label='NEXT'
          variant='contained'
          alwaysEnable
          color='primary'
          icon={null}
          sx={{ width: '180px' }}
          type='button'
          mutationOptions={{ onSuccess: handleNextClick }}
        />
      </div>

      <CancelAndReturnModal
        title='Are you sure you want to cancel creating a new Wellness quote?'
        onReturn={toggleIsCancelModalOpen}
        cancelTo={{ pathname: `/${RoutePaths.allQuotes}` }}
        open={isCancelModalOpen}
      />

      <SendQuoteByEmailModal
        showDialog={isSendEmailModalOpen}
        setShowDialog={toggleIsSendEmailModalOpen}
        quote={quote}
        additionalPayload={{ is_wellness_qf: true }}
      />
    </Toolbar>
  );
}

WellnessQuoteToolbar.propTypes = {
  edit: PropTypes.bool,
  selectedPlans: PropTypes.shape({
    price: PropTypes.number,
  }),
  quote: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default WellnessQuoteToolbar;
